/**
 * MODULE: domain/pages/frontend/components/editor/PagesCrmMentionView.tsx
 * PURPOSE: Inline CRM entity chip in the Pages note editor
 */

import { NodeViewWrapper } from '@tiptap/react';
import type { NodeViewProps } from '@tiptap/react';
import { useNavigate } from 'react-router-dom';
import { useIsPagesPublicView } from '../../context/PagesEditorViewModeContext';
import {
  CRM_MENTION_CHIP_CLASS,
  type CrmMentionEntityType,
  crmMentionPath,
} from '../../utils/crmMentionUtils';

export function PagesCrmMentionView({ node, selected }: NodeViewProps) {
  const navigate = useNavigate();
  const isPublicView = useIsPagesPublicView();
  const id = String(node.attrs.id ?? '');
  const entityType = (node.attrs.entityType ?? 'contact') as CrmMentionEntityType;
  const label = String(node.attrs.label ?? 'Untitled').trim() || 'Untitled';
  const chipClass = CRM_MENTION_CHIP_CLASS[entityType] ?? CRM_MENTION_CHIP_CLASS.contact;

  const openRecord = () => {
    if (isPublicView || !id) return;
    navigate(crmMentionPath(entityType, id));
  };

  const chipClasses = [
    'mx-0.5 inline-flex rounded px-1.5 py-0.5 text-xs font-medium align-baseline',
    chipClass,
    selected ? 'ring-2 ring-primary-300' : '',
  ].join(' ');

  return (
    <NodeViewWrapper as="span" className="inline">
      {isPublicView ? (
        <span
          className={chipClasses}
          data-testid={`pages-crm-mention-static-${id}`}
          data-entity-type={entityType}
          title="Sign in to Brazn to open this CRM record"
        >
          @{label}
        </span>
      ) : (
        <button
          type="button"
          onClick={openRecord}
          className={chipClasses}
          data-testid={`pages-crm-mention-${id}`}
          data-entity-type={entityType}
        >
          @{label}
        </button>
      )}
    </NodeViewWrapper>
  );
}
